export default "__VITE_ASSET__02c56844__"